import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { CountyDto } from "../../../services/dto";
import * as yup from "yup";
import { OptionsDto } from "../../../assets/utils/lib/optionsDto";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface CountyFormProps {
  data?: CountyDto | undefined;
  show: boolean;
  stateLookup: DropdownOption[] | undefined;
  onHide: () => void;
  onSave: (values: CountyDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().optional(),
});

export const CountyForm = (props: CountyFormProps) => {
  let title: string = "Edit County";
  let county: CountyDto | undefined = props.data;

  if (
    StringHelper.whenNullOrEmpty(county?.id, Constants.emptyGuid) ===
    Constants.emptyGuid
  ) {
    title = "New County";
  }

  const onSubmit = (data: CountyDto) => {
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  const isNew = !county?.id || county?.id === Constants.emptyGuid;
  const isLoading = props.show && !isNew && !county;
  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title={title}
      initialValues={county ?? {}}
      validationSchema={validationSchema}
      on_Submit={onSubmit}
    >
      <Form.Text
        name="name"
        placeholder="Enter text"
        label="Name"
        isLoading={isLoading}
      />
      <Form.TextArea
        name="description"
        rows={3}
        label="Description"
        isLoading={isLoading}
      />
      <Form.Dropdown
        name="stateId"
        label="State"
        isLoading={isLoading}
        options={props?.stateLookup}
        blankOption={{
          key: Constants.emptyGuid,
          display: "Select State",
          value: Constants.emptyString,
        }}
      />
    </Drawer.Form>
  );
};
